// React
import React from "react";
//-------------------------------------------------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------------------------------------------------
export default class CheckBox extends React.Component {
    render() {
        let { keyVal, defaultChecked, labelText } = this.props;
        return (React.createElement("div", { className: "md-checkbox" },
            React.createElement("input", { type: "checkbox", ref: keyVal, id: keyVal, defaultChecked: defaultChecked, className: "md-check" }),
            React.createElement("label", { htmlFor: keyVal },
                React.createElement("span", null),
                React.createElement("span", { className: "check" }),
                React.createElement("span", { className: "box" }),
                React.createElement("div", { className: "checkbox-label" }, labelText))));
    }
}
